<template>
	<div class="ao-list-item">
		<div class="ao-list-item__header">
			<AoAvatar
				v-if="isShowAvatar"
				:image="avatar"
				rounded="50"
				:text="avatarInitials"
				:class="['ao-list-item__avatar', { 'ao-list-item__avatar-fallback': !avatar }]"
				imageCover
			/>

			<div class="ao-list-item__info">
				<div class="ao-list-item__title">{{ title }}</div>
				<div class="ao-list-item__subtitle">
					<slot name="subtitle">
						{{ subTitle }}
					</slot>
				</div>
			</div>

			<div
				v-if="appendActionIconName || $slots['append']"
				class="ao-list-item__append"
			>
				<slot name="append">
					<AoBtn
						class="ao-list-item__appendBtn"
						color="muted"
						:appendIconName="appendActionIconName"
						@click="$emit('click:appendBtn')"
					/>
				</slot>
			</div>
		</div>
		<div
			v-if="$slots['default']"
			class="ao-list-item__content"
		>
			<slot name="default" />
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import AoAvatar from './AoAvatar.vue'
import AoBtn from './AoBtn.vue'

const props = defineProps({
	title: {
		type: String,
	},
	subTitle: {
		type: String,
	},
	avatar: {
		type: String,
	},
	appendActionIconName: {
		type: String,
	},
	isShowAvatar: {
		type: Boolean,
		default: true,
	},
})

defineEmits({
	'click:appendBtn': null,
})

const avatarInitials = computed(() => {
	const words = props.title?.trim().split(/\s+/) || []
	const initials = words
		.slice(0, 2)
		.map((w) => w[0]?.toUpperCase())
		.join('')
	return initials
})
</script>

<style lang="scss">
.ao-list-item {
	border-radius: 12px;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	gap: 12px;

	&__header {
		display: flex;
		align-items: center;
		font-weight: 500;
	}

	& &__avatar {
		&-fallback {
			background-color: #b8d5c2;
		}
		width: 36px;
		height: 36px;
		border-radius: 50%;
		font-weight: 500;
		font-size: 13.5px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
	}

	&__title {
		font-size: 12px;
	}

	&__subtitle {
		font-size: 12px;
		color: #86919d;
	}

	&__append {
		margin-left: auto;
		font-size: 1.2rem;
		color: #333;
	}

	& &__appendBtn {
		width: 36px;
		min-width: 36px;
		height: 36px;
	}
}
</style>
